import $ from "jquery";
import Swiper from 'swiper';


export function mainSlider() {
    //initialize swiper when document ready
    let swiper = new Swiper ('.main-slider', {
        // Optional parameters
        loop: false,
        autoplay: false,
        effect: 'slide',
        spaceBetween: 0,
        speed: 600,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

    });

    let swiperReferences = new Swiper ('.references-slider', {
        // Optional parameters
        loop: false,
        autoplay: false,
        effect: 'slide',
        slidesPerView: 3,
        spaceBetween: 40,
        speed: 300,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            1024: {
                slidesPerView: 3,
                spaceBetween: 40,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            500: {
                slidesPerView: 1,
                spaceBetween: 10,
            }
        }


    });

}




// WEBPACK FOOTER //
// ./src/js/components/swiper.js